export default __webpack_public_path__ + "static/2-cca280f95941798def36cc244f165ee2.jpg";